export const tokenState = thunkAPI => thunkAPI.getState().auth.token;
